import React from 'react';
import {getYear} from "date-fns"

const PriceTablePage = () => {
    return (
        <div className="p-3 lg:p-6">

            <h1 className="font-semibold mt-6 mb-5">Renticus müümise hinnakiri</h1>
            <h3 className="font-medium text-primary text-left">TAVAHINNAD</h3>

            {/* <table className="min-w-full table-auto border-collapse text-left mb-10 mt-4">
                <thead>
                    <tr className="bg-primary_light">
                        <th className="px-4 py-2 border border-gray-300 text-left">Kategooria</th>
                        <th className="px-4 py-2 border border-gray-300 text-left">Kasutaja määratud rendihind (€/päev)</th>
                        <th className=" px-4 py-2 border border-gray-300 text-left">Kuulutuse ülalhoidmise hind (€/nädal)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300" rowSpan={4}>Seadmed/Tehnika</td>
                        <td className="px-4 py-2 border border-gray-300">≤ 25€</td>
                        <td className="px-4 py-2 border border-gray-300">€3.00</td>
                    </tr>
                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">25€ - 50€</td>
                        <td className="px-4 py-2 border border-gray-300">€6.50</td>
                    </tr>
                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">50€ - 100€</td>
                        <td className="px-4 py-2 border border-gray-300">€8.50</td>
                    </tr>
                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">üle 100€</td>
                        <td className="px-4 py-2 border border-gray-300">€11.50</td>
                    </tr>

                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">Transport</td>
                        <td className="px-4 py-2 border border-gray-300">mistahes</td>
                        <td className="px-4 py-2 border border-gray-300">€10.50</td>
                    </tr>

                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">Kinnisvara</td>
                        <td className="px-4 py-2 border border-gray-300">mistahes</td>
                        <td className="px-4 py-2 border border-gray-300">€15.00</td>
                    </tr>

                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">Teenused</td>
                        <td className="px-4 py-2 border border-gray-300">mistahes</td>
                        <td className="px-4 py-2 border border-gray-300">€5.00</td>
                    </tr>
                </tbody>
            </table> */}

            <table className="min-w-full table-auto border-collapse text-left mb-10 mt-4">
                <thead>
                    <tr className="bg-primary_light">
                        <th className="px-4 py-2 border border-gray-300 text-left">Kuulutuse kuvamisaeg</th>
                        <th className=" px-4 py-2 border border-gray-300 text-left">Hind</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">1 kuu</td>
                        <td className="px-4 py-2 border border-gray-300">3€</td>
                    </tr>
                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">1 nädal</td>
                        <td className="px-4 py-2 border border-gray-300">1€</td>
                    </tr>
                </tbody>
            </table>

            <h3 className="font-medium text-primary text-left">SOODUSHINNAD – {getYear(new Date())} KAMPAANIA</h3>
            <p className='opacity-65 font-light text-left'>Soodus rakendub kuulutusele automaatselt.</p>

            <table className="min-w-full table-auto border-collapse text-left mt-4 mb-10">
                <thead>
                    <tr className="bg-primary_light">
                        <th className="px-4 py-2 border border-gray-300 text-left">Kategooria</th>
                        <th className="px-4 py-2 border border-gray-300 text-left">Kuulutuse periood</th>
                        <th className="px-4 py-2 border border-gray-300 text-left">Soodustus</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300" rowSpan={4}>Kõik kategooriad</td>
                        <td className="px-4 py-2 border border-gray-300">≤ 1 kuu</td>
                        <td className="px-4 py-2 border border-gray-300">Esimene kuulutus tasuta</td>
                    </tr>

                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">≥ 1 kuud</td>
                        <td className="px-4 py-2 border border-gray-300">Tavahinnast -10%</td>
                    </tr>

                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">≥ 3 kuud</td>
                        <td className="px-4 py-2 border border-gray-300">Tavahinnast -20%</td>
                    </tr>

                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">≥ 6 kuud</td>
                        <td className="px-4 py-2 border border-gray-300">Tavahinnast -30%</td>
                    </tr>
                </tbody>
            </table>

            <h3 className="font-medium text-primary text-left">ESILETÕSTMISE HINNAD</h3>
            <p className='opacity-65 font-light text-left'>Renticus saab valikulise lisatasu eest tõsta enda kuulutust teistest kasutajatest otsingulehel kõrgemale. Hetkel on esiletõstmise valikus ainult kindlad ajaperioodid.</p>
            <table className="min-w-full table-auto border-collapse text-left mt-4">
                <thead>
                    <tr className="bg-primary_light">
                        <th className="px-4 py-2 border border-gray-300 text-left">Kategooria</th>
                        <th className="px-4 py-2 border border-gray-300 text-left">Periood</th>
                        <th className="px-4 py-2 border border-gray-300 text-left">Hind</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300" rowSpan={3}>Kõik kategooriad</td>
                        <td className="px-4 py-2 border border-gray-300">1 nädal</td>
                        <td className="px-4 py-2 border border-gray-300">5€</td>
                    </tr>

                    <tr className="hover:bg-primary_light">
                        <td className="px-4 py-2 border border-gray-300">1 kuu</td>
                        <td className="px-4 py-2 border border-gray-300">15€</td>
                    </tr>

                 
                </tbody>
            </table>

            <p className='opacity-75 font-light text-left mt-10'>Kõik hinnad kehtivad praeguse seisuga. Renticul on õigus neid hindasid tulevikus muuta (eelneva hinnakirja alusel sooritatud makse summa selle tõttu ei muutu).</p>


        </div >
    );
}

export default PriceTablePage;
